/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, totalPages: NonNullable<unknown> }} Offerdetail_Changelog_Pageof2Inputs */

const id_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Halaman ${i?.page} dari ${i?.totalPages}`)
};

const ms_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Halaman ${i?.page} daripada ${i?.totalPages}`)
};

const da_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Side ${i?.page} af ${i?.totalPages}`)
};

const de_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seite ${i?.page} von ${i?.totalPages}`)
};

const en_us2_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.totalPages}`)
};

const es_es2_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.totalPages}`)
};

const es_mx2_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.totalPages}`)
};

const fil_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pahina ${i?.page} ng ${i?.totalPages}`)
};

const fr_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} sur ${i?.totalPages}`)
};

const it_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.page} di ${i?.totalPages}`)
};

const hu_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.page}. oldal / ${i?.totalPages}`)
};

const nl_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.page} van ${i?.totalPages}`)
};

const no_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Side ${i?.page} av ${i?.totalPages}`)
};

const pl_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Strona ${i?.page} z ${i?.totalPages}`)
};

const pt_br2_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.totalPages}`)
};

const pt_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.totalPages}`)
};

const ro_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.page} din ${i?.totalPages}`)
};

const fi_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sivu ${i?.page} / ${i?.totalPages}`)
};

const sv_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sida ${i?.page} av ${i?.totalPages}`)
};

const vi_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trang ${i?.page} / ${i?.totalPages}`)
};

const tr_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sayfa ${i?.page} / ${i?.totalPages}`)
};

const cs_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stránka ${i?.page} z ${i?.totalPages}`)
};

const bg_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Страница ${i?.page} от ${i?.totalPages}`)
};

const ru_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Страница ${i?.page} из ${i?.totalPages}`)
};

const uk_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сторінка ${i?.page} з ${i?.totalPages}`)
};

const ar_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`صفحة ${i?.page} من ${i?.totalPages}`)
};

const hi_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पृष्ठ ${i?.page} का ${i?.totalPages}`)
};

const th_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`หน้า ${i?.page} จาก ${i?.totalPages}`)
};

const ja_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.page} / ${i?.totalPages} ページ`)
};

const zh_cn2_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.page} 页，共 ${i?.totalPages} 页`)
};

const zh_hant1_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.page} 頁，共 ${i?.totalPages} 頁`)
};

const ko_offerdetail_changelog_pageof2 = /** @type {(inputs: Offerdetail_Changelog_Pageof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.page} / ${i?.totalPages} 페이지`)
};

/**
* | output |
* | --- |
* | "Page {page} of {totalPages}" |
*
* @param {Offerdetail_Changelog_Pageof2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_pageof2 = /** @type {((inputs: Offerdetail_Changelog_Pageof2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Pageof2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_pageof2(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_pageof2(inputs)
	if (locale === "da") return da_offerdetail_changelog_pageof2(inputs)
	if (locale === "de") return de_offerdetail_changelog_pageof2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_pageof2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_pageof2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_pageof2(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_pageof2(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_pageof2(inputs)
	if (locale === "it") return it_offerdetail_changelog_pageof2(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_pageof2(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_pageof2(inputs)
	if (locale === "no") return no_offerdetail_changelog_pageof2(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_pageof2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_pageof2(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_pageof2(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_pageof2(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_pageof2(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_pageof2(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_pageof2(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_pageof2(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_pageof2(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_pageof2(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_pageof2(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_pageof2(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_pageof2(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_pageof2(inputs)
	if (locale === "th") return th_offerdetail_changelog_pageof2(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_pageof2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_pageof2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_pageof2(inputs)
	return ko_offerdetail_changelog_pageof2(inputs)
});
export { offerdetail_changelog_pageof2 as "offerDetail.changelog.pageOf" }